module.exports = __webpack_public_path__ + "img/essensplan.4762f869.svg";